import { render, staticRenderFns } from "./PazientiProgettiModalEditComponent.vue?vue&type=template&id=6df16c68"
import script from "./PazientiProgettiModalEditComponent.vue?vue&type=script&lang=js"
export * from "./PazientiProgettiModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports